import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.sass']
})
export class TableHeaderComponent {
  @Input() tabs: string[] = ['View Subscriber'];
  @Output() tabChange = new EventEmitter<string>();

  activeTab: string = '';

  ngOnInit(): void {
    // Set the first tab as active by default
    if (this.tabs && this.tabs.length > 0) {
      this.activeTab = this.tabs[0];
    }
  }

  // Check if we should show the tab navigation bar
  get showTabs(): boolean {
    return this.tabs && this.tabs.length > 1;
  }

  selectTab(tab: string): void {
    this.activeTab = tab;
    this.tabChange.emit(tab);
  }
}
